import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/layout/header/Header";
import styles from "@/components/layout/header/Header.module.css";

const HomeHeader: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Header
            variant="default"
            rightContent={
                <div className={styles.links}>
                    <button
                        onClick={() => navigate("/social-contact")}
                        className={`${styles.link} ${styles.button}`}
                    >
                        CONTACTO
                    </button>
                    <button
                        onClick={() => navigate("/login")}
                        className={`${styles.link} ${styles.button}`}
                    >
                        INGRESO
                    </button>
                </div>
            }
        />
    );
};

export default HomeHeader;
